export type Word = {
  letters: (string | null)[];
  frequency: number;
};

export const WORDS: Word[] = [
  { letters: [null, "A", null, "E"], frequency: 127 },
  { letters: [null, "I", null, "E"], frequency: 99 },
  { letters: [null, "O", null, "E"], frequency: 97 },
  { letters: [null, "A", "R", null], frequency: 78 },
  { letters: [null, "O", "O", null], frequency: 75 },
  { letters: [null, "I", "N", null], frequency: 74 },
  { letters: [null, "E", "A", null], frequency: 72 },
  { letters: [null, "E", null, "T"], frequency: 70 },
  { letters: [null, "A", "N", null], frequency: 67 },
  { letters: [null, "E", "E", null], frequency: 63 },
  { letters: [null, "O", "R", null], frequency: 60 },
  { letters: [null, null, "L", "L"], frequency: 57 },
  { letters: [null, "O", "L", null], frequency: 57 },
  { letters: [null, null, "R", "E"], frequency: 56 },
  { letters: [null, "O", null, "T"], frequency: 56 },
  { letters: ["C", "O", null, null], frequency: 56 },
  { letters: [null, null, "C", "K"], frequency: 53 },
  { letters: [null, "A", "L", null], frequency: 53 },
  { letters: [null, "A", "I", null], frequency: 52 },
  { letters: ["S", null, "A", null], frequency: 51 },
  { letters: [null, null, "S", "T"], frequency: 50 },
  { letters: [null, "I", "L", null], frequency: 49 },
  { letters: [null, "A", null, "T"], frequency: 49 },
  { letters: [null, "A", "S", null], frequency: 49 },
  { letters: [null, null, "L", "E"], frequency: 48 },
  { letters: ["B", "A", null, null], frequency: 46 },
  { letters: ["L", "O", null, null], frequency: 46 },
  { letters: [null, "U", null, "E"], frequency: 46 },
  { letters: [null, null, "N", "E"], frequency: 46 },
  { letters: ["T", "O", null, null], frequency: 46 },
  { letters: ["M", "A", null, null], frequency: 44 },
  { letters: [null, null, "N", "G"], frequency: 44 },
  { letters: [null, "U", "R", null], frequency: 44 },
  { letters: ["T", "A", null, null], frequency: 43 },
  { letters: ["P", "O", null, null], frequency: 43 },
  { letters: [null, "A", null, "K"], frequency: 42 },
  { letters: [null, null, "N", "T"], frequency: 42 },
  { letters: ["W", "A", null, null], frequency: 42 },
  { letters: [null, "E", null, "L"], frequency: 42 },
  { letters: [null, "E", "L", null], frequency: 42 },
  { letters: ["B", "O", null, null], frequency: 42 },
  { letters: [null, "E", "R", null], frequency: 41 },
  { letters: [null, "O", null, "Y"], frequency: 41 },
  { letters: [null, "I", null, "T"], frequency: 41 },
  { letters: ["M", "O", null, null], frequency: 40 },
  { letters: [null, "O", "N", null], frequency: 40 },
  { letters: [null, "E", "N", null], frequency: 40 },
  { letters: [null, null, "T", "E"], frequency: 40 },
  { letters: [null, "O", null, "L"], frequency: 40 },
  { letters: [null, null, "A", "T"], frequency: 39 },
  { letters: [null, "U", "S", null], frequency: 39 },
  { letters: [null, "O", null, "K"], frequency: 39 },
  { letters: ["D", "O", null, null], frequency: 39 },
  { letters: ["S", null, null, "T"], frequency: 39 },
  { letters: ["H", "A", null, null], frequency: 38 },
  { letters: [null, null, "K", "E"], frequency: 38 },
  { letters: ["S", "O", null, null], frequency: 38 },
  { letters: [null, null, "N", "D"], frequency: 37 },
  { letters: [null, "A", null, "L"], frequency: 37 },
  { letters: [null, "U", "N", null], frequency: 37 },
  { letters: [null, "R", "A", null], frequency: 37 },
  { letters: [null, "O", null, "D"], frequency: 36 },
  { letters: [null, "E", null, "D"], frequency: 36 },
  { letters: ["P", "A", null, null], frequency: 36 },
  { letters: [null, null, "S", "H"], frequency: 36 },
  { letters: ["R", "A", null, null], frequency: 36 },
  { letters: [null, "O", null, "N"], frequency: 35 },
  { letters: [null, "L", "A", null], frequency: 35 },
  { letters: [null, "U", "L", null], frequency: 35 },
  { letters: [null, null, "S", "S"], frequency: 35 },
  { letters: [null, null, "N", "K"], frequency: 35 },
  { letters: ["L", null, null, "E"], frequency: 34 },
  { letters: ["L", "I", null, null], frequency: 34 },
  { letters: ["D", null, null, "E"], frequency: 34 },
  { letters: [null, "I", null, "K"], frequency: 34 },
  { letters: ["S", "A", null, null], frequency: 33 },
  { letters: [null, "O", "S", null], frequency: 33 },
  { letters: [null, null, "A", "R"], frequency: 33 },
  { letters: [null, null, "A", "L"], frequency: 33 },
  { letters: ["M", "I", null, null], frequency: 33 },
  { letters: [null, null, null, "E", "R"], frequency: 263 },
  { letters: [null, "A", null, "E", null], frequency: 152 },
  { letters: [null, "O", null, null, "Y"], frequency: 146 },
  { letters: [null, "A", null, null, "Y"], frequency: 144 },
  { letters: [null, "O", null, "E", null], frequency: 126 },
  { letters: ["S", null, null, null, "E"], frequency: 119 },
  { letters: ["S", null, "A", null, null], frequency: 119 },
  { letters: [null, null, "A", null, "E"], frequency: 118 },
  { letters: [null, "I", null, "E", null], frequency: 116 },
  { letters: [null, null, "I", null, "E"], frequency: 114 },
  { letters: [null, null, null, "E", "D"], frequency: 113 },
  { letters: ["S", "T", null, null, null], frequency: 108 },
  { letters: [null, "U", null, null, "Y"], frequency: 107 },
  { letters: ["S", null, "O", null, null], frequency: 101 },
  { letters: [null, "E", null, null, "Y"], frequency: 100 },
  { letters: [null, null, null, "A", "L"], frequency: 96 },
  { letters: [null, "R", "A", null, null], frequency: 96 },
  { letters: [null, "O", null, null, "E"], frequency: 91 },
  { letters: [null, null, "O", null, "E"], frequency: 90 },
  { letters: [null, "R", null, null, "E"], frequency: 90 },
  { letters: [null, null, null, "C", "H"], frequency: 89 },
  { letters: [null, null, null, "S", "E"], frequency: 89 },
  { letters: [null, "A", null, null, "E"], frequency: 89 },
  { letters: ["S", null, "I", null, null], frequency: 88 },
  { letters: [null, "R", "O", null, null], frequency: 87 },
  { letters: [null, null, null, "T", "Y"], frequency: 85 },
  { letters: [null, "I", null, null, "Y"], frequency: 85 },
  { letters: [null, null, "I", "N", null], frequency: 84 },
  { letters: [null, "A", "R", null, null], frequency: 84 },
  { letters: [null, "A", null, null, "R"], frequency: 83 },
  { letters: [null, "R", "I", null, null], frequency: 82 },
  { letters: [null, "O", "R", null, null], frequency: 81 },
  { letters: [null, null, null, "L", "Y"], frequency: 81 },
  { letters: [null, null, "R", null, "Y"], frequency: 79 },
  { letters: ["C", "O", null, null, null], frequency: 76 },
  { letters: [null, null, "A", "R", null], frequency: 76 },
  { letters: [null, "L", "A", null, null], frequency: 75 },
  { letters: ["S", null, null, "E", null], frequency: 75 },
  { letters: [null, "A", "N", null, null], frequency: 74 },
  { letters: [null, null, null, "L", "E"], frequency: 73 },
  { letters: ["S", null, "E", null, null], frequency: 73 },
  { letters: ["S", null, null, "R", null], frequency: 72 },
  { letters: ["S", "H", null, null, null], frequency: 72 },
  { letters: [null, "I", "N", null, null], frequency: 71 },
  { letters: [null, "E", null, null, "E"], frequency: 71 },
  { letters: ["S", "P", null, null, null], frequency: 71 },
  { letters: [null, null, "L", null, "Y"], frequency: 71 },
  { letters: [null, "I", null, null, "R"], frequency: 70 },
  { letters: ["C", "H", null, null, null], frequency: 69 },
  { letters: [null, "A", "L", null, null], frequency: 69 },
  { letters: [null, "A", null, "I", null], frequency: 69 },
  { letters: [null, null, "N", null, "Y"], frequency: 68 },
  { letters: [null, null, null, "D", "Y"], frequency: 68 },
  { letters: [null, "O", "U", null, null], frequency: 67 },
  { letters: [null, null, "R", null, "E"], frequency: 67 },
  { letters: ["M", "A", null, null, null], frequency: 67 },
  { letters: ["S", null, null, "L", null], frequency: 66 },
  { letters: [null, null, "A", "N", null], frequency: 66 },
  { letters: ["S", null, "R", null, null], frequency: 65 },
  { letters: ["P", null, null, null, "Y"], frequency: 64 },
  { letters: ["S", null, null, null, "Y"], frequency: 64 },
  { letters: ["S", null, null, "A", null], frequency: 64 },
  { letters: [null, "E", "R", null, null], frequency: 64 },
  { letters: [null, "U", "R", null, null], frequency: 64 },
  { letters: ["S", null, null, null, "T"], frequency: 63 },
  { letters: [null, null, null, "K", "Y"], frequency: 63 },
  { letters: ["B", "A", null, null, null], frequency: 62 },
  { letters: ["P", "A", null, null, null], frequency: 62 },
  { letters: [null, "H", "A", null, null], frequency: 62 },
  { letters: [null, "E", "A", null, null], frequency: 62 },
  { letters: [null, null, null, "E", "L"], frequency: 62 },
  { letters: ["C", "A", null, null, null], frequency: 62 },
  { letters: [null, null, "V", "E", null], frequency: 61 },
  { letters: [null, null, null, "G", "E"], frequency: 61 },
  { letters: ["T", "A", null, null, null], frequency: 61 },
  { letters: [null, null, "U", null, "E"], frequency: 60 },
  { letters: [null, "O", null, null, "R"], frequency: 60 },
  { letters: ["C", null, null, null, "E"], frequency: 60 },
  { letters: [null, null, null, "R", "Y"], frequency: 59 },
  { letters: [null, null, null, "T", "E"], frequency: 58 },
  { letters: [null, null, null, null, "E", "R"], frequency: 849 },
  { letters: [null, "A", null, null, "E", null], frequency: 404 },
  { letters: [null, null, null, null, "E", "D"], frequency: 377 },
  { letters: [null, "O", null, null, "E", null], frequency: 323 },
  { letters: [null, null, null, null, "L", "E"], frequency: 294 },
  { letters: [null, "E", null, null, "E", null], frequency: 268 },
  { letters: [null, null, null, "T", "E", null], frequency: 255 },
  { letters: [null, "I", null, null, "E", null], frequency: 243 },
  { letters: [null, null, null, "I", "N", null], frequency: 238 },
  { letters: [null, "A", null, null, null, "R"], frequency: 224 },
  { letters: ["S", null, null, null, "E", null], frequency: 213 },
  { letters: [null, "U", null, null, "E", null], frequency: 205 },
  { letters: [null, null, null, null, "L", "Y"], frequency: 204 },
  { letters: [null, null, "N", null, "E", null], frequency: 197 },
  { letters: [null, "A", "R", null, null, null], frequency: 196 },
  { letters: [null, null, "R", null, "E", null], frequency: 193 },
  { letters: [null, null, "A", null, "E", null], frequency: 189 },
  { letters: [null, null, null, "T", null, "R"], frequency: 187 },
  { letters: [null, null, null, "L", "E", null], frequency: 186 },
  { letters: [null, "O", null, null, null, "R"], frequency: 182 },
  { letters: [null, null, null, null, "N", "G"], frequency: 178 },
  { letters: ["R", "E", null, null, null, null], frequency: 177 },
  { letters: [null, "E", null, null, null, "E"], frequency: 176 },
  { letters: [null, null, null, "I", null, "E"], frequency: 174 },
  { letters: [null, "E", null, null, null, "R"], frequency: 169 },
  { letters: [null, null, null, "K", "E", null], frequency: 163 },
  { letters: ["B", null, null, null, "E", null], frequency: 162 },
  { letters: [null, null, null, "A", null, "E"], frequency: 162 },
  { letters: [null, "A", null, "I", null, null], frequency: 159 },
  { letters: [null, null, null, "D", "E", null], frequency: 159 },
  { letters: [null, null, "L", null, "E", null], frequency: 159 },
  { letters: [null, null, null, null, "E", "T"], frequency: 158 },
  { letters: [null, "A", "N", null, null, null], frequency: 157 },
  { letters: [null, null, null, null, "A", "L"], frequency: 155 },
  { letters: ["C", null, null, null, "E", null], frequency: 154 },
  { letters: [null, "O", null, null, null, "E"], frequency: 147 },
  { letters: ["C", "O", null, null, null, null], frequency: 145 },
  { letters: ["P", null, null, null, "E", null], frequency: 143 },
  { letters: ["S", null, null, null, null, "Y"], frequency: 143 },
  { letters: [null, null, null, null, "O", "N"], frequency: 140 },
  { letters: [null, "A", null, null, null, "E"], frequency: 139 },
  { letters: [null, "I", null, null, null, "R"], frequency: 138 },
  { letters: ["C", "A", null, null, null, null], frequency: 138 },
  { letters: [null, null, "S", null, "E", null], frequency: 136 },
  { letters: [null, null, null, null, "E", "N"], frequency: 132 },
  { letters: [null, null, "N", null, null, "R"], frequency: 131 },
  { letters: [null, "A", "L", null, null, null], frequency: 128 },
  { letters: [null, "A", null, null, null, "N"], frequency: 126 },
  { letters: [null, "A", null, "T", null, null], frequency: 125 },
  { letters: [null, null, null, "P", "E", null], frequency: 125 },
  { letters: [null, "E", null, "T", null, null], frequency: 124 },
  { letters: ["S", null, null, null, null, "E"], frequency: 122 },
  { letters: [null, "I", "N", null, null, null], frequency: 121 },
  { letters: [null, "O", "R", null, null, null], frequency: 120 },
  { letters: [null, null, "L", "L", null, null], frequency: 120 },
  { letters: ["S", "T", null, null, null, null], frequency: 119 },
  { letters: [null, null, "R", "I", null, null], frequency: 118 },
  { letters: [null, "U", null, null, null, "R"], frequency: 118 },
  { letters: ["S", null, null, null, null, "R"], frequency: 118 },
  { letters: ["S", null, "R", null, null, null], frequency: 117 },
  { letters: ["M", "A", null, null, null, null], frequency: 116 },
  { letters: ["S", null, "A", null, null, null], frequency: 114 },
  { letters: [null, null, null, "N", "E", null], frequency: 114 },
  { letters: [null, "I", null, null, null, "E"], frequency: 113 },
  { letters: [null, "A", null, null, "A", null], frequency: 113 },
  { letters: [null, "O", null, "I", null, null], frequency: 112 },
  { letters: [null, null, null, "E", null, "T"], frequency: 112 },
  { letters: [null, null, null, "G", "E", null], frequency: 111 },
  { letters: [null, "E", "A", null, null, null], frequency: 110 },
  { letters: [null, "A", null, null, "L", null], frequency: 110 },
  { letters: [null, "E", "R", null, null, null], frequency: 110 },
  { letters: ["L", null, null, null, "E", null], frequency: 110 },
  { letters: [null, null, "O", null, "E", null], frequency: 110 },
  { letters: [null, "U", "R", null, null, null], frequency: 109 },
  { letters: ["R", null, null, null, "E", null], frequency: 109 },
  { letters: ["D", "E", null, null, null, null], frequency: 109 },
  { letters: [null, "A", null, null, "O", null], frequency: 109 },
  { letters: [null, null, "T", null, "E", null], frequency: 108 },
  { letters: ["T", null, null, null, "E", null], frequency: 108 },
  { letters: [null, null, "I", null, "E", null], frequency: 107 },
];
